import React from 'react';
import { Route, Switch, useRouteMatch, Redirect } from 'react-router-dom';
import ReqList from './views/requests/List';
import Session from './views/sessions';
import { routes } from '../common/constants';

const Sessions = () => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route path={`${path}/requests`} component={ReqList} />
      <Route path={`${path}/sessions`} component={Session} />
      <Route
        path={`${path}`}
        exact
        render={() => <Redirect to={`${path}/${routes.SESSION_REQUESTS}`} />}
      />
      <Route render={() => <h1>404 - Not found</h1>} />
    </Switch>
  );
};

export default Sessions;
